var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"psd-container"},[(_vm.normal)?_c('img',{attrs:{"src":_vm.src}}):_c('div',{staticClass:"fail"},[_vm._v("此链接已失效")])])}
var staticRenderFns = []

export { render, staticRenderFns }